// extracted by mini-css-extract-plugin
export default {"top":"SortNavigation_top__PxQ9w","icon":"SortNavigation_icon__5JHUb"};